<template>
    <div class="card card--hover md:rounded-tl md:rounded-bl w-full md:w-1/3 flex flex-col justify-between">
        <h4 class="mb-2 tracking-wide uppercase">
            {{ title }}
        </h4>
        <p class="text-sm">
            {{ content }}
        </p>
        <span class="text-primary mt-3">Learn more</span>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        content: {
            type: String,
            required: true,
        },
    },
};
</script>

<style scoped>

</style>
